import { connectSearchBox } from "instantsearch.js/es/connectors/index.js";

const escapeHtml = (value = "") =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

// Show search form
export const chamfrSearchBox = connectSearchBox(
  (renderOptions, isFirstRender) => {
    const { query, refine, widgetParams } =
      renderOptions;
    const { container, label } = widgetParams;

    if (isFirstRender) {
      // Bind the form input and button
      container.innerHTML = `
		<form class="search-form" role="search">
		  <input
			type="search"
			class="search-form-input"
			placeholder="${escapeHtml(label)}"
			autocomplete="off"
			autocorrect="off"
			autocapitalize="off"
			spellcheck="false"
			maxlength="512"
			aria-label="Search"
			value="${escapeHtml(query)}"
			name="[query]"
		  />
      <span class="button-outer">
		    <button type="submit" class="search-form-btn" title="Submit the search query"></button>
      </span>
		</form>
	  `;

      const input = container.querySelector(".search-form-input");
      const form = container.querySelector(".search-form");

      // Add event listener for input typing
      input.addEventListener("input", (event) => {
        refine(event.target.value); // Update the search query dynamically as the user types
      });

      // Prevent default form submission
      form.addEventListener("submit", (event) => {
        event.preventDefault();
        refine(input.value); // Refine on form submission as well
      });
    }
  }
);
